export const REDUX_STORE_HOME = 'add_pocket_source'
export const SOURCE_NAME = 'Pocket'
